export const HTTP_METHODS = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
});

const DOMAINS = Object.freeze({
  CASE: 'v1/case/',
  CUSTOMERS: 'v1/customers/',
  FGTS: 'v1/fgts/',
  EULA: 'v1/tos/terms/',
  TRACKING: 'v1/events/',
  HASH: 'v1/hash',
  CHECK_COUPON: 'v1/check-coupon/',
});

/*
  # Endpoints #
*/

export const ENDPOINTS = Object.freeze({
  CASE: DOMAINS.CASE,
  GET_CASE: DOMAINS.CASE.concat(':id'),
  SEND_EMAIL: DOMAINS.CASE.concat(':id/send_email/'),
  CASE_PURCHASE: DOMAINS.CASE.concat(':case/purchase/'),
  CUSTOMERS: DOMAINS.CUSTOMERS,
  CUSTOMER_HASH: DOMAINS.HASH,
  UPLOAD_FILES: DOMAINS.FGTS.concat('upload/'),
  CHECK_FILES: DOMAINS.FGTS.concat('check-files/'),
  TRACKING: DOMAINS.TRACKING,
  FGTS: DOMAINS.FGTS,
  EULA: DOMAINS.EULA,
  EULA_PENDING: DOMAINS.EULA.concat('pending/'),
  EULA_ACCEPT: DOMAINS.EULA.concat(':id/accept_term/'),
  CHECK_COUPON: DOMAINS.CHECK_COUPON.concat('?code=:coupon'),
});
